var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93684 1.28644V2.15486H7.06316V1.28644C7.06316 1.0042 7.28026 0.765383 7.58421 0.765383C7.86645 0.765383 8.10526 1.0042 8.10526 1.28644V2.15486H8.97368C9.73355 2.15486 10.3632 2.78446 10.3632 3.54433V3.8917V4.9338V10.4917C10.3632 11.2733 9.73355 11.8812 8.97368 11.8812H2.02632C1.24474 11.8812 0.636842 11.2733 0.636842 10.4917V4.9338V3.8917V3.54433C0.636842 2.78446 1.24474 2.15486 2.02632 2.15486H2.89474V1.28644C2.89474 1.0042 3.11184 0.765383 3.41579 0.765383C3.69803 0.765383 3.93684 1.0042 3.93684 1.28644ZM1.67895 4.9338V10.4917C1.67895 10.6871 1.83092 10.8391 2.02632 10.8391H8.97368C9.14737 10.8391 9.32105 10.6871 9.32105 10.4917V4.9338H1.67895Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.f24d6bcf308c50e49f33455f8924fd39.svg";
export { ForwardRef as ReactComponent };